<template lang="pug">
.find-item(@click="goDetail")
  .avtar
    img(:src="detail.childUrl"
    style="height: 0.84rem; width: 0.64rem;"
    )
  .info
    .name
      span {{detail.childName}}
      span.right {{detail.childAge}}岁
    .lost-time
      span 走失时间：
      span.content {{detail.lostTime}}
    .lost-area
      span 走失地点：
      span.content {{detail.lostLocation}}
</template>

<script>
import router from '../../../router';
import { UBTUtils } from '../../../utils/ubt';

export default {
  name: 'FindingItem',
  props: {
    detail: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    goDetail() {
      const query = {
        caseId: this.detail.caseId,
      };
      router.push({
        path: 'reunion/detail',
        query,
      });
      UBTUtils.clickButton({
        pageId: 'platform_tuanyuan_list',
        buttonName: 'platform_tuanyuan_click_case',
        categoryId: 'platform',
        businessInfo: {},
      });
    },
  },
};
</script>

<style lang="less" scoped>
.find-item {
  margin: 0.16rem;
  background: #fff;
  display: inline-flex;

  .avtar {
    width: 0.64rem;
    height: 0.84rem;
  }

  .info {
    padding: 0.01rem 0 0 0.12rem;

    .name {
      height: 22px;
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC, sans-serif;
      font-weight: 500;
      color: #242729;
      line-height: 22px;
      margin-bottom: 0.04rem;

      .right {
        margin-left: 0.11rem;
      }
    }

    .lost-time {
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #879099;
      line-height: 17px;
      margin-bottom: 0.04rem;

      .content {
        color: #242729;
      }
    }

    .lost-area {
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC, sans-serif;
      font-weight: 400;
      color: #879099;

      .content {
        color: #242729;
      }
    }
  }
}

</style>
